<template>
    <footer class="text-center fixed-bottom">
        &copy; 2020 Axure Themes
    </footer>
</template>

<style scoped lang="scss">
    footer{
        background-color: var(--main-background);
        padding: 10px 0;
        color: #FFF
    }
</style>

<script>
export default {
    name: "Footer"
}
</script>